import React, { useEffect, useState } from 'react';

import CustomControlCheckbox from '../../elements/formElements/CustomControlCheckbox';
import FormGroup from '../../elements/formElements/FormGroup';

function WithdrawalMethodForm({ action, withdrawalMethodData, errors }) {
    const [withdrawalMethod, setWithdrawalMethod] = useState({
        name: '',
        slug: '',
        transaction_currency: '',
        user_fixed_fee: 0,
        user_fixed_fee_currency: '',
        user_percent_fee: 0,
        min_payment: 0,
        data: '',
        is_web: 0,
        is_mobile: 0,
        is_disabled: 0,
        min_withdrawal_amount: 4,
    });

    useEffect(() => {
        if (withdrawalMethodData) {
            setWithdrawalMethod({
                ...withdrawalMethod,
                name: withdrawalMethodData.name,
                slug: withdrawalMethodData.slug,
                transaction_currency: withdrawalMethodData.transaction_currency,
                user_fixed_fee: withdrawalMethodData.user_fixed_fee,
                user_fixed_fee_currency: withdrawalMethodData.user_fixed_fee_currency,
                user_percent_fee: withdrawalMethodData.user_percent_fee,
                data: withdrawalMethodData.data,
                is_web: withdrawalMethodData.is_web,
                is_mobile: withdrawalMethodData.is_mobile,
                is_disabled: withdrawalMethodData.is_disabled,
                min_withdrawal_amount: withdrawalMethodData.min_withdrawal_amount,
            });
        }
    }, [withdrawalMethodData]);

    function handleSubmit(event) {
        event.preventDefault();
        action(withdrawalMethod);
    }

    function getErrorFor(field) {
        if (errors[field]) {
            return errors[field][0];
        }
    }

    return (
        <form onSubmit={handleSubmit} autoComplete="do-not-autofill">
            <FormGroup
                type="text"
                field="name"
                label="Name"
                value={withdrawalMethod.name}
                error={getErrorFor('name')}
                handleChange={(event) =>
                    setWithdrawalMethod({
                        ...withdrawalMethod,
                        name: event.target.value,
                    })
                }
            />
            <FormGroup
                type="text"
                field="slug"
                label="Slug"
                value={withdrawalMethod.slug}
                error={getErrorFor('slug')}
                handleChange={(event) =>
                    setWithdrawalMethod({
                        ...withdrawalMethod,
                        slug: event.target.value,
                    })
                }
            />
            <FormGroup
                type="text"
                field="transaction_currency"
                label="Currency"
                value={withdrawalMethod.transaction_currency}
                error={getErrorFor('transaction_currency')}
                handleChange={(event) =>
                    setWithdrawalMethod({
                        ...withdrawalMethod,
                        transaction_currency: event.target.value,
                    })
                }
            />
            <FormGroup
                type="number"
                field="user_fixed_fee"
                label="User fixed fee"
                value={withdrawalMethod.user_fixed_fee}
                error={getErrorFor('user_fixed_fee')}
                handleChange={(event) =>
                    setWithdrawalMethod({
                        ...withdrawalMethod,
                        user_fixed_fee: event.target.value,
                    })
                }
            />
            <FormGroup
                type="text"
                field="user_fixed_fee_currency"
                label="User fixed fee currency"
                value={withdrawalMethod.user_fixed_fee_currency}
                error={getErrorFor('user_fixed_fee_currency')}
                handleChange={(event) =>
                    setWithdrawalMethod({
                        ...withdrawalMethod,
                        user_fixed_fee_currency: event.target.value,
                    })
                }
            />
            <FormGroup
                type="number"
                field="user_percent_fee"
                label="User percent fee"
                value={withdrawalMethod.user_percent_fee}
                error={getErrorFor('user_percent_fee')}
                handleChange={(event) =>
                    setWithdrawalMethod({
                        ...withdrawalMethod,
                        user_percent_fee: event.target.value,
                    })
                }
            />
            <CustomControlCheckbox
                field="is_web"
                value={withdrawalMethod.is_web === 1}
                label="Is Web"
                error={getErrorFor('is_web')}
                handleChange={(event) =>
                    setWithdrawalMethod({ ...withdrawalMethod, is_web: event.target.checked ? 1 : 0 })
                }
            />
            <CustomControlCheckbox
                field="is_mobile"
                value={withdrawalMethod.is_mobile === 1}
                label="Is Mobile"
                error={getErrorFor('is_mobile')}
                handleChange={(event) =>
                    setWithdrawalMethod({ ...withdrawalMethod, is_mobile: event.target.checked ? 1 : 0 })
                }
            />
            <CustomControlCheckbox
                field="is_disabled"
                value={withdrawalMethod.is_disabled === 1}
                label="Is disabled"
                error={getErrorFor('is_disabled')}
                handleChange={(event) =>
                    setWithdrawalMethod({ ...withdrawalMethod, is_disabled: event.target.checked ? 1 : 0 })
                }
            />
            <FormGroup
                type="text"
                field="data"
                value={withdrawalMethod.data}
                label="Data"
                error={getErrorFor('data')}
                handleChange={(event) => setWithdrawalMethod({ ...withdrawalMethod, data: event.target.value })}
            />
            <FormGroup
                type="number"
                field="Min withdrawal"
                value={withdrawalMethod.min_withdrawal_amount}
                label="Min withdrawal"
                error={getErrorFor('Min withdrawal')}
                handleChange={(event) =>
                    setWithdrawalMethod({ ...withdrawalMethod, min_withdrawal_amount: event.target.value })
                }
            />
            <button type="submit" className="btn btn-primary">
                Save
            </button>
        </form>
    );
}

export default WithdrawalMethodForm;
